import { useState, useMemo } from "react";
import THAILAND_DATA from "./thailand.json"; // วางไฟล์นี้ใน src/ หรือ adjust path ให้ตรง

/**
 * useThaiAddress
 * Cascade: Province → Amphoe (District) → Tambon (Sub-District) → Postal Code auto-fill
 *
 * Usage:
 *   const { provinces, amphoes, tambons, selected, handleProvinceChange,
 *           handleAmphoeChange, handleTambonChange } = useThaiAddress(form, setForm);
 */
export default function useThaiAddress(form, setForm) {
  // ── Derived lists ──────────────────────────────────────────────
  const provinces = useMemo(
    () => [...new Set(THAILAND_DATA.map((r) => r.province))].sort(),
    []
  );

  const amphoes = useMemo(() => {
    if (!form.city) return [];
    return [...new Set(
      THAILAND_DATA.filter((r) => r.province === form.city).map((r) => r.amphoe)
    )].sort();
  }, [form.city]);

  const tambons = useMemo(() => {
    if (!form.city || !form.district) return [];
    return [...new Set(
      THAILAND_DATA
        .filter((r) => r.province === form.city && r.amphoe === form.district)
        .map((r) => r.district)  // "district" field = tambon ในไฟล์ JSON
    )].sort();
  }, [form.city, form.district]);

  // ── Handlers ───────────────────────────────────────────────────
  const handleProvinceChange = (e) => {
    const province = e.target.value;
    setForm((prev) => ({
      ...prev,
      city:        province, // city = Province
      district:    "",       // district = Amphoe
      subdistrict: "",       // subdistrict = Tambon
      postalCode:  "",
    }));
  };

  const handleAmphoeChange = (e) => {
    const amphoe = e.target.value;
    setForm((prev) => ({
      ...prev,
      district:    amphoe,
      subdistrict: "",
      postalCode:  "",
    }));
  };

  const handleTambonChange = (e) => {
    const tambon = e.target.value;
    // auto-fill postal code
    const found = THAILAND_DATA.find(
      (r) =>
        r.province === form.city &&
        r.amphoe   === form.district &&
        r.district === tambon
    );
    setForm((prev) => ({
      ...prev,
      subdistrict: tambon,
      postalCode:  found ? found.zipcode : "",
    }));
  };

  return {
    provinces,
    amphoes,
    tambons,
    handleProvinceChange,
    handleAmphoeChange,
    handleTambonChange,
  };
}
